module.exports = __webpack_public_path__ + "static/media/cert_6.16f65b00.jpg";